module.exports = __webpack_public_path__ + "img/facebook.3206dcbb.svg";